$( document ).ready(function() {
    
/** HOMEPAGE SLIDER **/

  window.debounce=function(b,f,c){var a;return function(){var d=this,e=arguments,g=c&&!a;clearTimeout(a);a=setTimeout(function(){a=null;c||b.apply(d,e)},f);g&&b.apply(d,e)}};
    document.addEventListener('shopify:section:load', function(e){
      if ( e.target.id == 'shopify-section-header' ) {
        fixVhByVars();
      }
  });

  window.themeAssets = {
     arrowDown: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12 8" style="enable-background:new 0 0 12 8; width: 12px; height: 8px;" xml:space="preserve"><polyline points="0,2 2,0 6,4 10,0 12,2 6,8 0,2 "/></svg>',
     arrowRight: '<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" style="width:21px; height: 10px;" viewBox="0 0 21 10"><path d="M21.000,5.000 L15.000,10.000 L15.000,6.000 L-0.000,6.000 L-0.000,4.000 L15.000,4.000 L15.000,0.000 L21.000,5.000 Z" /></svg>',
     iconHeart: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25; width: 25px; height: 25px;" xml:space="preserve"><g transform="translate(0,-952.36218)"><path d="M1.8,956.2c-2.4,2.4-2.4,6.3,0,8.8l10.6,10.8c3.5-3.6,7.1-7.2,10.6-10.8c2.4-2.4,2.4-6.3,0-8.8c-2.4-2.4-6.2-2.4-8.6,0l-1.9,2l-2-2C8,953.8,4.2,953.8,1.8,956.2z"/></g></svg>',
     iconTwitter: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><path d="M25.83 5.57c-.94.47-2 .7-3.05.82 1.06-.7 1.88-1.64 2.35-2.94-1.06.6-2.1 1.06-3.4 1.3-.94-1.06-2.35-1.64-3.87-1.64-2.94 0-5.28 2.35-5.28 5.28 0 .47 0 .82.12 1.17-4.47-.23-8.35-2.34-10.93-5.5-.47.82-.7 1.64-.7 2.7 0 1.88.94 3.4 2.35 4.46a4.25 4.25 0 0 1-2.35-.7v.12c0 2.58 1.88 4.7 4.23 5.17-.47 0-.94.12-1.4.12-.35 0-.7 0-.94-.12.6 2.1 2.58 3.64 4.93 3.64-1.88 1.53-4.1 2.35-6.58 2.35-.47 0-.82 0-1.3-.12C2.35 23.18 5.17 24 8.1 24c9.75 0 15.03-8.1 15.03-15.03v-.7a9.91 9.91 0 0 0 2.7-2.7z"/></svg>',
     iconInstagram: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><path d="M13 2.4l5.2.1c1.3.1 1.9.3 2.4.4.6.2 1 .5 1.5 1s.7.9 1 1.5c.2.5.4 1.1.4 2.4.1 1.4.1 1.8.1 5.2l-.1 5.2c-.1 1.3-.3 1.9-.4 2.4-.2.6-.5 1-1 1.5s-.9.7-1.5 1c-.5.2-1.1.4-2.4.4-1.4.1-1.8.1-5.2.1s-3.9 0-5.2-.1-1.9-.3-2.4-.4c-.6-.2-1-.5-1.5-1s-.7-.9-1-1.5c-.2-.5-.4-1.1-.4-2.4-.1-1.4-.1-1.8-.1-5.2l.1-5.2c.1-1.3.3-1.9.4-2.4.2-.6.5-1 1-1.5s.9-.7 1.5-1c.5-.2 1.1-.4 2.4-.4 1.3-.1 1.7-.1 5.2-.1m0-2.3L7.7.2C6.3.2 5.4.4 4.5.7c-.8.4-1.5.8-2.3 1.5C1.5 3 1.1 3.7.7 4.5.4 5.4.2 6.3.1 7.7V13l.1 5.3c.1 1.4.3 2.3.6 3.1.3.9.8 1.6 1.5 2.3s1.4 1.2 2.3 1.5c.8.3 1.8.5 3.1.6 1.4.1 1.8.1 5.3.1l5.3-.1c1.4-.1 2.3-.3 3.1-.6.9-.3 1.6-.8 2.3-1.5s1.2-1.4 1.5-2.3c.3-.8.5-1.8.6-3.1.1-1.4.1-1.8.1-5.3l-.1-5.3c-.1-1.4-.3-2.3-.6-3.1-.3-.9-.8-1.6-1.5-2.3S22.3 1.1 21.4.8c-.8-.3-1.8-.5-3.1-.6S16.5.1 13 .1zm0 6.3c-3.7 0-6.6 3-6.6 6.6s3 6.6 6.6 6.6 6.6-3 6.6-6.6-2.9-6.6-6.6-6.6zm0 10.9c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3 4.3 1.9 4.3 4.3-1.9 4.3-4.3 4.3z"/><circle cx="19.9" cy="6.1" r="1.6"/></svg>',
     iconZoom: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 36 36" style="enable-background:new 0 0 36 36; width: 36px; height: 36px;" xml:space="preserve"><polyline points="16,8 13,11 8,6 6,8 11,13 8,16 16,16 "/><polyline points="28,16 25,13 30,8 28,6 23,11 20,8 20,16 "/><polyline points="20,28 23,25 28,30 30,28 25,23 28,20 20,20 "/><polyline points="8,20 11,23 6,28 8,30 13,25 16,28 16,20 "/></svg>'
   };
  window.themeCartSettings = 'overlay';

  window.shop_money_format = "${{amount}}";

  if ( 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ) {
    document.querySelector('body').classList.remove('no-touchevents');
    document.querySelector('body').classList.add('touchevents');
  } 


  /** HOMEPAGE COMPARISON SLIDER **/

  var divisor = document.getElementById("divisor"),
  slider = document.getElementById("slider");
  function moveDivisor() { 
      divisor.style.width = slider.value+"%";
  }
  
  /**
  
  if ($('.template-product').length) {
  
  const modalBtn = document.querySelector(".open-modal");
  const modal = document.querySelector(".modal__wrapper");
  const overlay = document.querySelector(".modal_overlay");
  const closeBtn = document.querySelector(".modal__close");

  const openModal = () => {
    modal.classList.remove("hidden");
    overlay.classList.remove("hidden");
  };

  const closeModal = () => {
    modal.classList.add("hidden");
    overlay.classList.add("hidden");
  };

  // open modal function
  modalBtn.addEventListener("click", openModal);

  // closing modal&overlay on click and on ESC
  closeBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);
  document.addEventListener("keydown", (e) => {
    if (e.keyCode === 27 && !modal.classList.contains("hidden")) {
      closeModal();
    }
  });
  
  }
  
  **/
  
  $(".satisfaction-guarantee p a").on('click', function() {
      $('.satisfaction-guarantee .modal__wrapper').removeClass('hidden');
  });
  
   /** FOOD AS MEDICINE MODALS **/
  
  $(".food-as-medicine li p a").on('click', function() {
     var modal = $(this).parents().children('.modal__wrapper');
      $('.modal_overlay').removeClass('hidden');
      $(modal).removeClass('hidden');
  });
  
  $(".modal_close_btn").on('click', function() {
     var modal = $(this).parents().children('.modal__wrapper');
      $('.modal_overlay').addClass('hidden');
      $(modal).addClass('hidden');
  });
  
  $(".modal_overlay").on('click', function() {
     var modal = $(this).parents().children('.modal__wrapper');
      $('.modal_overlay').addClass('hidden');
      $('.modal__wrapper').addClass('hidden');
  });


  $('.video-switcher__title').on('click', function() {
    $(this).closest('.video-switcher').data('tab', $(this).data('tab'));
  });

});